import Cookies from "js-cookie";

const ACCESS_TOKEN_KEY = "access_token";
const EXPIRE_DATE_KEY = "expireDate";

export function getAccessToken() {
  return Cookies.get(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token: string, expiresIn: number) {
  const expireDate = new Date(Date.now() + expiresIn * 1000);
  Cookies.set(ACCESS_TOKEN_KEY, token, { path: "/", expires: expireDate });
  Cookies.set(EXPIRE_DATE_KEY, expireDate.toISOString(), { path: "/", expires: expireDate });
}

export function clearAccessToken() {
  Cookies.remove(ACCESS_TOKEN_KEY, { path: "/" });
  Cookies.remove(EXPIRE_DATE_KEY, { path: "/" });
}
